<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">Upload Protocol Permission Letter</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="alert alert-info">
      <strong>Instructions:</strong>
      <ul class="mb-0">
        <li>Upload 1-5 PDF files (maximum 20MB each)</li>
        <li>Files will be stored for today's date</li>
        <li>If files already exist for today, they will be replaced</li>
      </ul>
    </div>

    <div *ngIf="!uploadSuccess" class="upload-section">
      <div class="form-group">
        <label for="fileInput" class="btn btn-primary">
          <i class="fa fa-upload"></i> Select PDF Files
        </label>
        <input 
          type="file" 
          id="fileInput"
          class="d-none" 
          accept=".pdf"
          multiple
          (change)="onFileSelect($event)"
          [disabled]="isUploading">
      </div>

      <div *ngIf="files.length > 0" class="selected-files">
        <h6>Selected Files:</h6>
        <div class="file-list">
          <div *ngFor="let file of files; let i = index" class="file-item">
            <div class="file-info">
              <i class="fa fa-file-pdf-o text-danger"></i>
              <span class="file-name">{{ file.name }}</span>
              <span class="file-size">({{ formatFileSize(file.size) }})</span>
            </div>
            <button 
              type="button" 
              class="btn btn-sm btn-outline-danger"
              (click)="removeFile(i)"
              [disabled]="isUploading">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="uploadError" class="alert alert-danger mt-3">
        <strong>Error:</strong> {{ uploadError }}
      </div>
    </div>

    <div *ngIf="uploadSuccess" class="text-center py-4">
      <i class="fa fa-check-circle text-success" style="font-size: 48px;"></i>
      <h5 class="mt-3 text-success">Files Uploaded Successfully!</h5>
    </div>
  </div>
  <div class="modal-footer">
    <button 
      type="button" 
      class="btn btn-secondary" 
      (click)="closeModal()"
      [disabled]="isUploading">
      {{ uploadSuccess ? 'Close' : 'Cancel' }}
    </button>
    <button 
      *ngIf="!uploadSuccess"
      type="button" 
      class="btn btn-primary" 
      (click)="uploadFiles()"
      [disabled]="isUploading || files.length === 0">
      <span *ngIf="isUploading">
        <i class="fa fa-spinner fa-spin"></i> Uploading...
      </span>
      <span *ngIf="!isUploading">
        <i class="fa fa-upload"></i> Upload Files
      </span>
    </button>
  </div>
</div>
